module.exports = __webpack_public_path__ + "img/bg.3ef9e1a4.jpg";